// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4750":"505ff0f8","9925":"c8b141a9"}[chunkId] + ".chunk.css";
};